import { Stack, StackProps } from '@mui/material';

import { drawerCssVars } from './cssVars';

export const DrawerContent = ({
  testId,
  ...props
}: StackProps & { testId?: string }) => {
  return (
    <Stack
      px={drawerCssVars.getters.horizontalPadding()}
      data-testid={testId}
      {...props}
    />
  );
};
